import { without } from 'ramda';

import { TQueryData } from '../types';

export const filterOutEstimationById = (previousData: TQueryData | undefined, idToDelete: number): TQueryData => {
  if (!previousData) {
    return {
      pages: [],
      pageParams: [],
    };
  }

  let res: TQueryData = {
    ...previousData,
    pages: previousData.pages.map(page => ({
      estimationHistory: page.estimationHistory.filter(({ estimationId }) => estimationId !== idToDelete),
      totalCount: page.totalCount,
    })),
  };

  res = res.pages.reduce((acc, page, i) => {
    if (page.estimationHistory.length) {
      return acc;
    }

    return {
      pages: without([page], acc.pages),
      pageParams: without([acc.pageParams[i]], acc.pageParams),
    };
  }, res);

  return res;
};
